import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

class Loader extends React.Component {
    render() {
        if (!this.props.isVisible) {
            return null;
        }

        return (
            <div className="loader">
                <Isvg src="/svg/loader.svg" />
            </div>
        );
    }
}

Loader.propTypes = {
    isVisible: PropTypes.bool,
};

Loader.defaultProps = {
    isVisible: true,
};

export default Loader;
